import Vue from "vue";//引入vue
import Vuex from 'vuex';//引入vuex
Vue.use(Vuex);//挂在vuex
const store = new Vuex.Store({//创建一个Store 实例
    state:{//用来存储数据
        ashen:localStorage.getItem('theme') || 'true',// 假的为黑 真的为白
        SongId:-1,//点击播放歌曲 传入的歌曲 id
        SongURL:'',//下载歌曲的路径
        SqHone:false,//社区和首页的显示跟隐藏 false为首页 true为社区
        LoginStatus:JSON.parse(localStorage.getItem("Kp_state")) || '',//登录状态
        BottomPlayer:false,//判断底部播放器是否显示隐藏 true 显示 false 隐藏

    },
    mutations:{//用来盖面state 里面的数据
        //拿到歌曲id 进行复制 传参 播放
        changeSongId(state,outsideId){
            state.SongId = outsideId;
            state.BottomPlayer = true;
        },
        //下载歌曲
        DownloadSongs(state,urls){
            console.log(urls);
            state.SongURL = urls.music_url;
             // 使用Blob来处理文件的下载
             fetch(state.SongURL).then(response => {
                if (!response.ok) {
                    throw new Error('网络错误');
                }
                    return response.blob(); // 将数据转换为Blob对象
                })
                .then(blob => {
                    const url = window.URL.createObjectURL(blob); // 创建Blob URL
                    const a = document.createElement('a'); // 创建一个链接元素
                    a.href = url; // 设置href
                    a.download = `${urls.names}.mp3`; // 文件名
                    document.body.appendChild(a);
                    a.click(); // 触发下载
                    a.remove(); // 移除链接元素
                    window.URL.revokeObjectURL(url); // 释放资源
                    this.$message.error('已加入下载列表中');
                })
                .catch(error => {
                console.error('下载失败', error);
            });
        },
        //社区和首页的显示和隐藏
        changeSqHone(state,sqIndex){
            state.SqHone = sqIndex;
            console.log(state.SqHone)
        },
        //登录状态
        // zhuangtai(state,writeIn){
        //     state.LoginStatus = writeIn;
        //     console.log(state.LoginStatus.username)
        //     console.log(writeIn)
        // }
    }
})
// window.store = store // 挂在store在window上，并与在控制台进行测试
export default store// 把store示例导出下载

